<div class="container-fluid">
    <app-page-title title="Manage Vendor Services"></app-page-title>
    <form [formGroup]="servicesForm" (ngSubmit)="addServices();" (keydown.enter)="useEnterKey ? $event.preventDefault() : addServices()">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="vendor" class="form-label">Vendor </label>
                                    <input type="text" class="form-control form-control-sm" id="vendor"
                                        formControlName="txtVendor" maxlength="50"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || servicesForm.get('txtVendor').touched) && servicesForm.get('txtVendor').errors}" >


                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="servicename" class="form-label">Service <span
                                            class="mandatory">*</span></label>
                                    <input type="text" class="form-control form-control-sm" id="servicename"
                                        formControlName="txtService" maxlength="100"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || servicesForm.get('txtService').touched) && servicesForm.get('txtService').errors}" >
                                    <div *ngIf="(isFormSubmitted || servicesForm.get('txtService').touched) && servicesForm.get('txtService').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="servicesForm.get('txtService').errors.required">Service is
                                            required</span>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="minweight" class="form-label">Weight </label>
                                <div class="input-group mb-2">
                                    <span class="input-group-text group-label-sm">Min</span>
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtMinWeight" (change)="checkWeight()" >
                                    <span class="input-group-text group-label-sm">Max</span>
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtMaxWeight" (change)="checkWeight()" >
                                    <span class="input-group-text group-label-sm">Unit</span>
                                    <ng-select [items]="unitOptions" bindLabel="name" [clearable]="false" [bindValue]="'name'"
                                        [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlUnit" placeholder="Select"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom" >
                                    </ng-select>
                                 
                                </div>
                            </div>
                            <div class="col-md-3">
                                <label for="minweight" class="form-label">Charges Above </label>
                                <div class="input-group mb-2">
                                    <span class="input-group-text group-label-sm">Size</span>
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtChargeAboveSize" >
                                    <span class="input-group-text group-label-sm">Weight</span>
                                    <input type="number" class="form-control form-control-sm"
                                        formControlName="txtChargeAboveWeight" >
                                </div>
                            </div>


                        </div>

                        <div class="row">
                            <div class="col-md-2">
                                <div>
                                    <label for="proformadocument" class="form-label">Proforma document required</label>
                                    <div class="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                            formControlName="chkProformaDocument" >
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div>
                                    <label for="proformadetails" class="form-label">Proforma details required</label>
                                    <div class="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                            formControlName="chkProformaDetails" >
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-1">
                                <div class="">
                                    <label for="status" class="form-label">Status</label>
                                    <div class="form-check form-switch form-switch-md">
                                        <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                                            formControlName="status" >
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-2">
                <div class="button-items">
                    <button type="submit" class="btn btn-primary btn-sm w-sm" >{{ editMode ? 'Update' : 'Save'}}</button>
                    <button type="button" class="btn btn-primary btn-sm w-sm" (click)="resetForm()">Reset</button>
                    <a routerLink="/setup/vendors"><button type="button"
                            class="btn btn-secondary btn-sm w-sm">Cancel</button></a>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="permConfig.isViewAllowed">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase"> Services List </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                    class="ag-theme-balham" [rowData]="rowData" [columnDefs]="columnDefs"
                                    [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                    [pagination]="true" (gridOptions)="gridOptions" (gridReady)="onGridReady($event)">
                                </ag-grid-angular>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</div>